import { isObject } from '../../../../shared/helpers/is-object';
import { EventTypes, IframeSize, PostMessage } from './types';

export const isValidMessage = (message: PostMessage): message is PostMessage =>
    message && Object.prototype.hasOwnProperty.call(message, 'event') && message.event in EventTypes;

const isAbsoluteUrl = (payload: string): boolean => {
    try {
        // eslint-disable-next-line no-new
        new URL(payload);
        return true;
    } catch {
        return false;
    }
};

const isRelativeUrl = (payload: string): boolean => {
    try {
        // eslint-disable-next-line no-new
        new URL(payload, 'http://example.com');
        return true;
    } catch {
        return false;
    }
};

export const isValidUrl = (payload: string): boolean =>
    Boolean(payload) && (isAbsoluteUrl(payload) || isRelativeUrl(payload));

export const isIframeSize = (payload: unknown): payload is IframeSize => {
    if (!payload || !isObject(payload)) {
        return false;
    }

    return (
        Object.keys(payload).length === 0 ||
        ('width' in payload && typeof payload.width === 'number') ||
        ('height' in payload && typeof payload.height === 'number')
    );
};
